export default __webpack_public_path__ + "static/media/notbadmovies.1aac736e.webp";